/* 
 * Problem.js
 * 
 * @author Olivier van der Pool for Ranj
 */

export default class Problem {
    constructor() {
        this._id = "";
        this._description = "";
        this._solutions = [];
    }

    getID() {
        return this._id;
    }

    setID(value) {
        this._id = value;
    }

    getDescription() {
        return this._description;
    }

    setDescription(value) {
        this._description = value;
    }

    getSolutions() {
        return this._solutions;
    }

    addSolution(solution) {
        this._solutions.push(solution);
    }

    getSolutionByID(id) {
        for (let i = 0; i < this._solutions.length; i++) {
            if (this._solutions[i].getID() === id) {
                return this._solutions[i];
            }
        }
        return null;
    }

    getCorrectSolution() {
        for (let i = 0; i < this._solutions.length; i++) {
            if (this._solutions[i].isCorrect) {
                return this._solutions[i];
            }
        }
        return null;
    }

    isArgumentCorrect(solutionid, argumentid) {
        const solution = this.getSolutionByID(solutionid);
        if (solution === null) return false;
        const correct = solution.isArgumentCorrect(argumentid);

        return correct;
    }
}